// src/data/mockData.js
import { Users, TrendingUp, Activity, Landmark } from 'lucide-react';

export const JOURNEY_STAGES = [
  { id: 'registered', label: 'Registered', color: 'bg-slate-500' },
  { id: 'kyc_pending', label: 'KYC Pending', color: 'bg-orange-500' },
  { id: 'kyc_approved', label: 'KYC Approved', color: 'bg-blue-500' },
  { id: 'deposit_made', label: 'First Deposit', color: 'bg-indigo-500' },
  { id: 'active', label: 'Active', color: 'bg-green-500' },
  { id: 'dormant', label: 'Dormant', color: 'bg-gray-500' },
  { id: 'frozen', label: 'Frozen', color: 'bg-red-500' }
];

export const MOCK_CLIENTS_FULL = [
  // 1. James Sterling - SCENARIO: Threshold Met & Verified (Green Bar, No Button)
  { 
    id: 'CL-4921', name: 'James Sterling', email: 'james@sterling.com', phone: '+44 7700 900077', referralCode: 'NOM-JS4921',
    status: 'active', tier: 'Elite', risk: 'Low', 
    trading: { equity: 14502.50, margin: 240, pos: 4 },
    banking: { iban: 'GB29 NOMM 2033 4411 22', balance: 4500.00, currency: 'GBP' },
    crypto: { walletAddress: '0x71...9A2', balance: 12500.00, holdings: [{asset: 'BTC', amount: 0.4}] },
    avatar: 'JS', agent: 'Sarah Sales',
    aiInteractions: 0, // <--- Triggers "Adoption" Mission
    education: { progress: 100 },
    documents: [], 
    sumsub: {
       status: 'Approved',
       checks: [
          { name: 'Liveness Check', status: 'Passed', time: '2025-10-12 10:45' },
          { name: 'ID Validation', status: 'Passed', time: '2025-10-12 10:46' },
          { name: 'AML Watchlist', status: 'Passed', time: '2025-10-12 10:46' }
       ]
    },
    lifetimeDeposit: 25000.00, 
    deposit: 25000.00, 
    advancedKycStatus: 'Completed', 
    
    bioRecoveryStatus: 'approved',
    sumsubCertificate: 'SUM-ID-9921-X88',
    securityRiskScore: 12, 
    securityEvents: [
        { id: 1, type: 'Failed Login', details: 'Incorrect Password (3x)', location: 'London, UK', ip: '82.11.40.22', device: 'iPhone 14 Pro', time: '2h ago', risk: 'Medium' },
        { id: 2, type: 'New Device', details: 'Authorized via Email', location: 'London, UK', ip: '82.11.40.22', device: 'MacBook Air', time: '5d ago', risk: 'Low' }
    ],
    tickets: [
        { 
            id: 'TKT-992', 
            subject: 'Crypto Deposit Delay', 
            status: 'Open', 
            priority: 'High', 
            created: '2025-12-10 14:30',
            history: [
                { type: 'email', sender: 'Client', text: 'I sent 0.4 BTC about 2 hours ago and it is still not showing in my wallet. TxID: 882...991', time: 'Yesterday, 14:30' },
                { type: 'email', sender: 'System', text: 'Ticket Created. Priority set to High.', time: 'Yesterday, 14:30' },
                { type: 'email', sender: 'Support', text: 'Hi James, checking the blockchain now.', time: 'Yesterday, 14:45' }
            ],
            whatsapp: [
                { type: 'whatsapp', sender: 'Client', text: 'Hey, anyone there?', time: 'Yesterday, 14:28' },
                { type: 'whatsapp', sender: 'Nommia Bot', text: 'Hello! I am the Nommia AI Assistant. How can I help you today?', time: 'Yesterday, 14:28' },
                { type: 'whatsapp', sender: 'Client', text: 'My bitcoin deposit is stuck.', time: 'Yesterday, 14:29' },
                { type: 'whatsapp', sender: 'Nommia Bot', text: 'I understand. I have created a high-priority ticket (TKT-992) for our blockchain team. An agent will join this chat shortly.', time: 'Yesterday, 14:30' },
                { type: 'whatsapp', sender: 'Live Agent', text: 'Hi James, Sarah here. I see the ticket. Looking into it now.', time: 'Yesterday, 14:46' }
            ]
        }
    ],
    communications: [
        { id: 'COM-001', type: 'system', subject: 'Welcome to Nommia', date: '2025-10-10 09:00', status: 'Delivered', content: '<div style="padding:20px; text-align:center;"><h1 style="color:#D97706;">Welcome to NOMMIA</h1><p>Dear James,</p><p>Your account has been successfully verified. You can now deposit funds and start trading.</p><br/><button style="background:#2563EB; color:white; padding:10px 20px; border:none; border-radius:5px;">Deposit Now</button></div>' },
        { id: 'COM-002', type: 'whatsapp', subject: 'WhatsApp Chat', date: '2025-10-12 14:20', status: 'Resolved', messages: [
            { sender: 'Client', text: 'Hi, I need help with my leverage settings.', time: '14:20' },
            { sender: 'Nommia Bot', text: 'I can help with that. Are you looking to increase or decrease your leverage?', time: '14:20' },
            { sender: 'Client', text: 'Increase to 1:500', time: '14:21' },
            { sender: 'Live Agent', text: 'Hi James, I can process that for you. One moment please.', time: '14:25' }
        ]},
        { id: 'COM-003', type: 'email', subject: 'Re: Document Verification', date: '2025-11-01 10:00', status: 'Replied', messages: [
            { sender: 'Client', text: 'I have attached the new utility bill as requested.', time: '10:00' },
            { sender: 'Support', text: 'Thank you James, we have received it and updated your profile.', time: '11:15' }
        ]}
    ],
    systemNotifications: [
        { id: 1, type: 'OTP', event: 'Login Verification Code (SMS)', status: 'Sent', time: '15 mins ago' },
        { id: 2, type: 'Password', event: 'Password Reset Request', status: 'Completed', time: '2 days ago' },
        { id: 3, type: 'Email', event: 'Email Verification Link', status: 'Expired', time: '5 days ago' },
        { id: 4, type: 'System', event: 'Account Tier Upgrade (Elite)', status: 'Auto-Applied', time: '1 month ago' },
        { id: 5, type: 'Security', event: 'New Device Authorization', status: 'Approved', time: '2 months ago' }
    ],
    firstName: 'James', lastName: 'Sterling', role: 'Trader', country: 'United Kingdom', referrer: 'Google Ads',
    dob: '1985-04-12', pob: 'London', nationality: 'British',
    address: { door: '12', street: 'Baker Street', city: 'London', postcode: 'NW1 6XE', country: 'UK' },
    pep: false, taxResidency: 'United Kingdom',
    gdpr: { marketing: true, dataDownload: false, deletionRequest: false }
  },

  // 2. Elena Kovic (Original Data Preserved)
  { 
    id: 'CL-8822', name: 'Elena Kovic', email: 'elena.k@example.com', phone: '+44 7700 900123', referralCode: 'NOM-EK8822',
    status: 'frozen', tier: 'Trader', risk: 'High', 
    trading: { equity: 520.00, margin: 110, pos: 1 },
    banking: { iban: 'GB29 NOMM 5521 0001 99', balance: 12000.00, currency: 'EUR' },
    crypto: { walletAddress: '0x88...BB1', balance: 0.00, holdings: [] },
    avatar: 'EK', agent: 'Mike Compliance',
    documents: [{ type: 'Passport', status: 'Review', expiry: '2024-01-01', aiScore: 45, source: 'Manual Upload' }],
    sumsub: null, 
    lifetimeDeposit: 12000.00,
    deposit: 12000.00,
    advancedKycStatus: 'Pending Review',
    securityRiskScore: 92, 
    securityEvents: [
        { id: 1, type: 'Mismatched IP', details: 'Login from High Risk Country', location: 'Lagos, Nigeria', ip: '192.168.1.1', device: 'Unknown Android', time: '2h ago', risk: 'Critical' },
        { id: 2, type: 'Failed Reset', details: 'Incorrect Current Password', location: 'Belgrade, Serbia', ip: '10.0.0.55', device: 'Chrome / Windows', time: '1d ago', risk: 'High' },
        { id: 3, type: 'Failed Login', details: 'Brute Force Attempt (50+)', location: 'Moscow, Russia', ip: '45.22.11.00', device: 'Botnet Signature', time: '2d ago', risk: 'Critical' }
    ],
    tickets: [],
    communications: [],
    systemNotifications: [],
    notes: [{ date: '2025-12-09', author: 'Compliance AI', text: 'Frozen due to pattern match: Layering.' }],
    firstName: 'Elena', lastName: 'Kovic', role: 'Trader', country: 'Serbia', referrer: 'IB-991',
    dob: '1992-08-22', pob: 'Belgrade', nationality: 'Serbian',
    address: { door: '5A', street: 'High St', city: 'Belgrade', postcode: '11000', country: 'Serbia' },
    pep: true, taxResidency: 'Serbia',
    gdpr: { marketing: false, dataDownload: true, deletionRequest: false }
  },

  // 3. Marcus Chen (Original Data Preserved)
  { 
    id: 'CL-3310', name: 'Marcus Chen', email: 'm.chen@tech.cn', phone: '+86 138 0013 8000', referralCode: 'NOM-MC3310', 
    status: 'kyc_pending', tier: 'Trader', risk: 'Medium', 
    trading: { equity: 0, margin: 0, pos: 0 }, 
    banking: { iban: 'Pending', balance: 0, currency: 'USD' }, 
    crypto: { walletAddress: 'Pending', balance: 0.00, holdings: [] }, 
    avatar: 'MC', agent: 'Unassigned', 
    documents: [], tickets: [], communications: [], systemNotifications: [], notes: [], 
    sumsub: null, 
    lifetimeDeposit: 0.00, 
    deposit: 0.00, 
    advancedKycStatus: 'Not Required', 
    securityRiskScore: 5, securityEvents: [], 
    firstName: 'Marcus', lastName: 'Chen', role: 'IB', country: 'China', referrer: 'Direct', 
    dob: '1990-01-01', pob: 'Shanghai', nationality: 'Chinese', 
    address: { door: '88', street: 'Nanjing Rd', city: 'Shanghai', postcode: '200000', country: 'China' }, 
    pep: false, taxResidency: 'China', 
    gdpr: { marketing: true, dataDownload: false, deletionRequest: false } 
  },

  // 4. Sarah Connor - SCENARIO: Threshold Met & Check REQUIRED (Red Bar + Trigger Button)
  { 
    id: 'CL-1029', name: 'Sarah Connor', email: 's.connor@sky.net', phone: '+1 310 555 0199', referralCode: 'NOM-SC1029', 
    status: 'deposit_made', tier: 'Pro', risk: 'Low', 
    trading: { equity: 250420.00, margin: 500, pos: 12 }, 
    banking: { iban: 'US29 NOMM 1010 2200 11', balance: 15000.00, currency: 'USD' }, 
    crypto: { walletAddress: '0x99...CC2', balance: 42000.50, holdings: [] }, 
    avatar: 'SC', agent: 'Dave Manager', 
    aiInteractions: 50,
    education: { status: 'stuck', progress: 35 }, // <--- Triggers "Education" Mission
    documents: [], tickets: [], communications: [], systemNotifications: [], notes: [], 
    sumsub: { status: 'Approved', checks: [{ name: 'Liveness Check', status: 'Passed', time: '2025-01-15' }, { name: 'ID Validation', status: 'Passed', time: '2025-01-15' }, { name: 'AML Watchlist', status: 'Passed', time: '2025-01-15' }] }, 
    
    lifetimeDeposit: 5500.00, 
    deposit: 5500.00,
    advancedKycStatus: 'Required', 
    
    securityRiskScore: 65, 
    securityEvents: [{ id: 1, type: 'Login Location', details: 'Access from new country (Spain)', location: 'Madrid, Spain', ip: '192.168.0.1', device: 'Chrome / Mac', time: '1h ago', risk: 'High' }, { id: 2, type: 'Failed Login', details: 'Incorrect Password (2x)', location: 'Los Angeles, USA', ip: '10.0.0.1', device: 'iPhone', time: '1w ago', risk: 'Medium' }], 
    firstName: 'Sarah', lastName: 'Connor', role: 'Country IB Manager', country: 'USA', referrer: 'System', dob: '1984-05-12', pob: 'Los Angeles', nationality: 'American', address: { door: '101', street: 'Pico Blvd', city: 'Los Angeles', postcode: '90015', country: 'USA' }, pep: false, taxResidency: 'USA', gdpr: { marketing: true, dataDownload: false, deletionRequest: true } 
  }
];

export const MOCK_COMPLIANCE_CASES = [
  { id: 'CASE-2025-992', client: 'Elena Kovic', clientId: 'CL-8822', type: 'AML', trigger: 'AML Alert: Layering Pattern', severity: 'Critical', detected: '2 hours ago by Agentic AI', status: 'Open', description: 'Client deposited crypto and immediately requested fiat withdrawal to a different jurisdiction.', evidence: [ { id: 1, label: 'Crypto Deposit (10k USDT)', status: 'Flagged' }, { id: 2, label: 'Immediate Withdrawal Request (Fiat)', status: 'Flagged' }, { id: 3, label: 'IP Address Mismatch (Login: Nigeria, KY: UK)', status: 'Flagged' } ], checklist: ['Verify Source of Funds', 'Check IP History', 'Video Interview'] },
  { id: 'CASE-2025-995', client: 'Davide Rossi', clientId: 'CL-9912', type: 'Trading', trigger: 'Prohibited: Latency Arbitrage', severity: 'High', detected: '15 mins ago by Trade Guardian', status: 'Open', description: 'Multiple trades opened and closed within 300ms during news events.', evidence: [ { id: 1, label: 'Avg Trade Duration < 300ms', status: 'Confirmed' }, { id: 2, label: '100% Win Rate on NFP News', status: 'Flagged' } ], checklist: ['Check LP Execution Logs', 'Compare Feed Timestamps', 'Review Terms of Business'] },
  { id: 'CASE-2025-998', client: 'Marcus Chen', clientId: 'CL-3310', type: 'AML', trigger: 'AML Alert: Structuring / Smurfing', severity: 'Medium', detected: '1 day ago by Banking Core', status: 'Under Review', description: 'Multiple deposits of €9,000 over 3 days.', evidence: [ { id: 1, label: 'Deposit €9,500 (Mon)', status: 'Logged' }, { id: 2, label: 'Deposit €9,200 (Tue)', status: 'Logged' }, { id: 3, label: 'Deposit €9,800 (Wed)', status: 'Logged' } ], checklist: ['Request Source of Wealth', 'Check Tax Residency', 'File SAR Report'] }
];

export const MOCK_SARS = [
    { id: 'SAR-2025-001', status: 'Draft', client: 'Elena Kovic', reason: 'Suspicion of Money Laundering (Layering)', created: '2025-12-10', aiDraft: { summary: 'The subject, Elena Kovic, opened an account on 2025-12-01...', indicators: ['Rapid movement of funds'] }, formData: { q1_reason: 'Suspicion of Money Laundering - Layering', q2_narrative: '', q3_subject_details: 'Name: Elena Kovic, DOB: 1992-08-22, Nationality: Serbian', q4_transaction_details: '10k USDT Deposit -> €9.2k Fiat Withdrawal' }, audit: [ { user: 'Agentic AI', action: 'Draft Created', time: '2025-12-10 14:00' }, { user: 'Mike Compliance', action: 'Draft Opened', time: '2025-12-10 14:05' } ] },
    { id: 'SAR-2025-000', status: 'Submitted', client: 'Davide Rossi', reason: 'Market Manipulation', created: '2025-11-20', submissionId: 'FIU-UK-8821-X99', submittedDate: '2025-11-21', aiDraft: { summary: 'N/A' }, formData: { q1_reason: 'Market Abuse', q2_narrative: 'Subject engaged in latency arbitrage...', q3_subject_details: 'Davide Rossi, Italian National', q4_transaction_details: '25 Trades < 300ms duration' }, audit: [ { user: 'Agentic AI', action: 'Draft Created', time: '2025-11-20 09:00' }, { user: 'Mike Compliance', action: 'Submitted to NCA', time: '2025-11-21 10:05' } ] }
];

export const STAFF_METRICS = [
  { name: 'Sarah Sales', role: 'Sales', kyc: 45, tickets: 5, time: '15m', score: 92 },
  { name: 'Mike Compliance', role: 'Compliance', kyc: 120, tickets: 2, time: '2h 00m', score: 88 },
  { name: 'Dave Manager', role: 'Manager', kyc: 10, tickets: 12, time: '1h 20m', score: 95 },
];

export const STAFF_LOGS = [
  { id: 1, staff: 'Sarah Sales', action: 'Approved KYC', target: 'Marcus Chen', time: '2m ago' },
  { id: 2, staff: 'Mike Compliance', action: 'Froze Account', target: 'Elena Kovic', time: '2h ago' },
  { id: 3, staff: 'Dave Manager', action: 'Adjusted Leverage', target: 'Sarah Connor', time: '4h ago' }
];

export const MOCK_IB_TREE = [
   { id: 'IB-001', name: 'Global FX Partners', level: 'Master IB', clients: 1240, rebate: '$45,200', subIbs: [ { id: 'IB-022', name: 'London Trading Group', level: 'Sub IB', clients: 350, rebate: '$12,500' }, { id: 'IB-045', name: 'Crypto Signals UK', level: 'Sub IB', clients: 120, rebate: '$4,200' } ] }, { id: 'IB-002', name: 'Asia Pacific Wealth', level: 'Master IB', clients: 890, rebate: '$32,100', subIbs: [] }
];

export const MOCK_LIVE_IB_FEED = [
  { id: 'IB-991', name: 'Global FX Partners', referrals: 1240, deposits: '$8.5M', volLife: '$420M', volMonth: '$35M', vol24h: '$1.2M', trend: 'up' },
  { id: 'IB-772', name: 'Crypto Signals UK', referrals: 120, deposits: '$950k', volLife: '$45M', volMonth: '$8.2M', vol24h: '$300k', trend: 'down' },
  { id: 'IB-334', name: 'Sarah\'s Trading Group', referrals: 85, deposits: '$420k', volLife: '$12M', volMonth: '$1.5M', vol24h: '$50k', trend: 'up' }
];

export const MOCK_CAMPAIGNS = [
   { id: 1, name: 'Crypto Winter Promo', channel: 'Meta Ads', spend: '$5,000', leads: 450, funded: 85, cpa: '$58', roi: '420%' },
   { id: 2, name: 'Gold Spread Zero', channel: 'Google Search', spend: '$12,000', leads: 120, funded: 90, cpa: '$133', roi: '210%' }
];